import React, { useEffect, useRef, useState } from "react";
import TopRightActionLinks from "../../TopRightActionLinks";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import { useParams } from "react-router-dom";
import DomainChip from "../../../../HtmlElements/DomainChip";
import * as FeatherIcon from "react-feather";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function ProductAndSolutionsPortfolio({ portfolioData }) {
  const { clientName, competitorName } = useParams();
  const [tabData, setTabData] = useState({});
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [showConversationModal, setShowConversationModal] = useState(false);

  // Refs for each category block
  const categoryRefs = useRef({});

  useEffect(() => {
    if (portfolioData[0]?.response?.fields) {
      const grouped = {};

      Object.values(portfolioData[0]?.response?.fields).forEach((category) => {
        const categoryName = category.category_name || "Unknown Category";

        const products = Object.values(category.products || {}).map(
          (product) => ({
            product: product.name || "-",
            description: product.description || "-",
            source: product?.sources || product?.source || "-",
          })
        );

        grouped[categoryName] = {
          strategic_role: category.strategic_role || "",
          products,
        };
      });

      setTabData(grouped);

      // Expand the first category by default
      // const firstKey = Object.keys(grouped)[0];
      // if (firstKey) setExpandedCategory(firstKey);
    }
  }, [portfolioData]);

  useEffect(() => {
    if (expandedCategory && categoryRefs.current[expandedCategory]) {
      categoryRefs.current[expandedCategory].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [expandedCategory]);

  const actions = [
    // { type: "filter", title: "Table View", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => setShowConversationModal((prev) => !prev),
    // },
  ];

  const toggleCategory = (categoryName) => {
    setExpandedCategory((prev) =>
      prev === categoryName ? null : categoryName
    );
  };

  return (
    <div className="product_and_innovation_wrapper mb-4">
      <div className="table_head_block">
        <div className="table_subblock_left">
          <h5 className="table_head">Product & Solutions Portfolio</h5>
          <p className="table_para">
            Explore {competitorName ?? "Tailored Chemical Products"}'s strategic
            product lines with revenue, market share, and product-level detail.
          </p>
        </div>
        <TopRightActionLinks actions={actions} />
      </div>

      {/* Category accordion cards */}
      {Object.entries(tabData).map(([categoryName, data], idx) => (
        <div
          className="water_adh_block"
          key={idx}
          onClick={() => toggleCategory(categoryName)}
          style={{ cursor: "pointer" }}
          ref={(el) => (categoryRefs.current[categoryName] = el)}
        >
          <div className="head_block">
            <div className="head_subblock">
              <div className="head_icon_text">
                <h5 className="head_text_chip">
                  <div className="name_subname">
                    <span className="category_name_cl">{categoryName} </span>
                    <span className="label_next_to_head">
                      {data.strategic_role &&
                        data.strategic_role.split("–")?.[0]}
                    </span>
                  </div>
                  <span style={{ marginLeft: "8px" }}>
                    {expandedCategory === categoryName ? (
                      <FeatherIcon.ChevronDown width="16" height="16" />
                    ) : (
                      <FeatherIcon.ChevronRight width="16" height="16" />
                    )}
                  </span>
                </h5>

                {data.strategic_role && (
                  <p className="head_subtext">
                    {data.strategic_role && data.strategic_role.split("–")?.[1]}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Show table only if this category is expanded */}
          {expandedCategory === categoryName && (
            <div className="table_block_chip">
              <div className="table-responsive">
                <table className="custom-resizable-table">
                  <thead>
                    <tr className="custom-resizable-table-header">
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Key Products
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Description
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Source
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.products.map((row, pIdx) => (
                      <tr
                        key={pIdx}
                        className="gtr-row"
                        style={{ backgroundColor: "#fff" }}
                      >
                        <td className="gtr-cell">
                          <p>{row.product}</p>
                        </td>
                        <td className="gtr-cell">
                          <p>{row.description}</p>
                        </td>
                        <td className="gtr-cell">
                          <div
                            className="gtr-cell-content-container"
                            style={{ display: "block" }}
                          >
                            {Array.isArray(row.source) ? (
                              row.source.map((url, i) => (
                                <div
                                  key={i}
                                  style={{
                                    wordBreak: "break-all",
                                    marginBottom: "4px",
                                  }}
                                >
                                  <DomainChip url={url} />
                                </div>
                              ))
                            ) : (
                              <ParsedTextWithLinks text={row.source} />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                    {data.products.length === 0 && (
                      <tr>
                        <td colSpan={3} className="text-center text-muted">
                          No products available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      ))}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Product &
                    Solutions Portfolio
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={"Product & Solution Portfolio"} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default ProductAndSolutionsPortfolio;
